import script from "./MaterialLibrary.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialLibrary.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialLibrary.vue?vue&type=style&index=0&id=0f11f376&lang=css"

const __exports__ = script;

export default __exports__